import { HelperText } from './helper-text';
import styled from 'styled-components';

export const SubtitleText = styled(HelperText)`
  font-size: 16px;
  font-style: normal;
  margin-top: 0;
`;
